export const API_BASE_URL = process.env.REACT_APP_API_SERVER;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_SERVER;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const DOWNLOAD_SERVER = process.env.REACT_APP_DOWNLOAD_SERVER;
export const HOST = process.env.REACT_APP_HOST || process.env.HOST;

// Support
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
export const SUPPORT_REQUEST_ENDPOINT = process.env.REACT_APP_SUPPORT_REQUEST_ENDPOINT;

// Google OAuth
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;